import { createResourceShortlistAssociationCacheReconciler } from 'v4/entities/associations/resource__shortlist/resource__shortlist.cache';
import {
  reconcileShortlistsWithMergedResources,
  reconcileShortlistsWithSystemEffects
} from 'v4/entities/shortlist/shortlist.cache';
import { queryClient } from 'v4/migration/queryClientSingleton';
import { reconcileCallsheetsWithMergedResources } from 'store/v1/callsheets/callsheets.cache';
import { myReduxProxy } from 'v5/api/_common/reduxProxy.connected';
import { myMessageService } from 'v5/services/internal/MessageService/MessageService.connected';

export function initMigrationCacheReconciler() {
  createResourceShortlistAssociationCacheReconciler(queryClient);
  reconcileShortlistsWithSystemEffects(queryClient, myMessageService);
  reconcileShortlistsWithMergedResources(queryClient, myReduxProxy);
  reconcileCallsheetsWithMergedResources(queryClient, myReduxProxy);
}
